import { faq } from '../content.js'

export default function Faq() {
  return (
    <section className="section alt" id="faq">
      <div className="container narrow">
        <div className="section-head"><h2>Frequently asked questions</h2></div>
        {faq.map((x) => (
          <details key={x.q} className="faq">
            <summary>{x.q}</summary>
            <p>{x.a}</p>
          </details>
        ))}
      </div>
    </section>
  )
}
